export function groupBy<T>(items: Array<T>, keyGetter: (input: T) => string): { [m: string]: T[] } {
  const map = {} as { [v: string]: Array<T> };

  for (const item of items) {
    const key = keyGetter(item);
    if (typeof key !== 'undefined') {
      if (typeof map[key] === 'undefined') {
        map[key] = [item];
      } else {
        map[key].push(item);
      }
    }
  }

  return map;
}
